import { Service, ContractConstants, DOFlow,} from './../constants/actionType'
import { InHomeUtils } from './../util/inhomeUtils'
import * as buildProductAction from './../action/buildProduct';
import { catchJSException } from './../service/logService';
import { store } from './../index';


export const prefetch = (action, dispatch, visitId, addlInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart,
    isDCTinCart, isDoFlow, isChecked = false, serviceInCart,buildProductState=null,saveState=null,hoaFlowDetails = null,lqState=null,voicetn="", isRouterAPIInvoked = false) => {
        console.trace();

    try {        
            serviceInCart = InHomeUtils.isNull(serviceInCart) ? "" : serviceInCart;
            selectedCoreServices = InHomeUtils.isNull(selectedCoreServices) ? "" : selectedCoreServices;
            let coreServiceCount = InHomeUtils.isNotEmpty(serviceInCart) && InHomeUtils.isNotEmpty(serviceInCart?.split(",")[0]) ? serviceInCart?.split(",").length : 0;            
            let flow = action;
            let servicesQualified = InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotEmpty(addlInfo.servicesQualified) ? addlInfo.servicesQualified : null;
            let servicesInfo = {
                isData: serviceInCart.indexOf('DATA') > -1,
                isDataAdd: serviceInCart.indexOf('DATA') > -1 && selectedCoreServices.indexOf('DATA') === -1,
                isDataRemove: serviceInCart.indexOf('DATA') === -1 && selectedCoreServices.indexOf('DATA') > -1,
                isDataChange: flow.indexOf(Service.internet) > -1 && serviceInCart.indexOf('DATA') > -1 && selectedCoreServices.indexOf('DATA') > -1,
                isDataQualified:  InHomeUtils.isNull(servicesQualified) || (InHomeUtils.isNotEmpty(servicesQualified) && servicesQualified.isDataQualified),

                isTV: serviceInCart.indexOf('VIDEO') > -1,
                isTVAdd: serviceInCart.indexOf('VIDEO') > -1 && selectedCoreServices.indexOf('VIDEO') === -1,
                isTVRemove: serviceInCart.indexOf('VIDEO') === -1 && selectedCoreServices.indexOf('VIDEO') > -1,
                isTVChange: flow.indexOf(Service.tv) > -1 && serviceInCart.indexOf('VIDEO') > -1 && selectedCoreServices.indexOf('VIDEO') > -1,
                isVideoQualified:  InHomeUtils.isNull(servicesQualified) || (InHomeUtils.isNotEmpty(servicesQualified) && servicesQualified.isVideoQualified),

                isVoice: serviceInCart.indexOf('FIOS_VOICE') > -1,
                isVoiceAdd: serviceInCart.indexOf('FIOS_VOICE') > -1 && selectedCoreServices.indexOf('FIOS_VOICE') === -1,
                isVoiceRemove: serviceInCart.indexOf('FIOS_VOICE') === -1 && selectedCoreServices.indexOf('FIOS_VOICE') > -1,
                isVoiceQualified:  InHomeUtils.isNull(servicesQualified) || (InHomeUtils.isNotEmpty(servicesQualified) && servicesQualified.isVoiceQualified),

                isPerks: serviceInCart.indexOf('PERKS') > -1,
                isPerksAdd: serviceInCart.indexOf('PERKS') > -1 && selectedCoreServices.indexOf('PERKS') === -1,
                isPerksRemove: serviceInCart.indexOf('PERKS') === -1 && selectedCoreServices.indexOf('PERKS') > -1,
                isPerksQualified:  InHomeUtils.isNull(servicesQualified) || (InHomeUtils.isNotEmpty(servicesQualified) && servicesQualified.isPerksQualified),

                isLocalTV: isLocalTVInCart, 
                is300M: false,
                is1G: false,
                isDCT: isDCTinCart
            };
            const isStreamline =  window?.location?.href?.includes('inhome/streamlineordering');
            let isDirectPopular  = window?.location?.href?.includes('/inhome/popularPlans?lq2=y');
            let isPopularPerf  = window?.location?.href?.includes('/inhome/popularPlans?isPerf=y');
            let visit_Id = window.sessionStorage.getItem("visit_id") || '';
            
            if(isDirectPopular || isPopularPerf) {
                doPopularPlanprefetch(dispatch, visit_Id, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, 'Popular', action, buildProductState,saveState,hoaFlowDetails,lqState,voicetn);
            }else if(isStreamline){
                doStreamlineprefetch(dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow, action, buildProductState,saveState,hoaFlowDetails,lqState,voicetn, isRouterAPIInvoked);
            }else{
                doprefetch(dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow, action, buildProductState,saveState,hoaFlowDetails,lqState,voicetn);
            }
        }        
        catch (ex) {
            catchJSException('prefetch', visitId, 'prefetch', ex);
        }
    }

    
    const doPopularPlanprefetch = (dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow, action, buildProductState=null,saveState=null,hoaFlowDetails=null,lqState=null,voicetn="") => {
        try {        
        let flowType = addlInfo && addlInfo.flowType;        
        let fdvQualified = false;
        let fiosFiveBasicChannels = [];
        let doKey = isDoFlow.DOIDValue;
        let isDataHOAContract = false;
        let isHOAFlow = false;
        window.localStorage.setItem('isLboTriggered', false);
        if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.hoabundle) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap) && Object.keys(buildProductState.hoabundle.hoaresponse.defaultMap).length>0){
            isHOAFlow = true;
           if(InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['internet']) || InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['data'])){
               isDataHOAContract = true;
            }
        } 
        if(buildProductState && buildProductState.tv && buildProductState.tv.fiosFiveBasicChannels){
            fiosFiveBasicChannels = buildProductState.tv.fiosFiveBasicChannels;
        }
        if (addlInfo && InHomeUtils.isNotNull(addlInfo.servicesQualified) && InHomeUtils.isNotNull(addlInfo.servicesQualified.isVoiceQualified) && addlInfo.servicesQualified.isVoiceQualified){
            fdvQualified = true;
        }
            
        if (flowType === "") {
            flowType = "NC";
        } 
        if(addlInfo.isFCPflow !== true && InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow) {
            doKey = "CLA"; // classic address
        }
        if(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow){
            dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: isHOAFlow , hoaLoadertext : "Fetching Products"} }); 
        }
        if (flow === "Popular"){
             buildProductAction.fetchDataMTM(dispatch, visitId, flowType, addlInfo.couponFlowType, action, 0,true, addlInfo, servicesInfo)
             fetchFiosPerksMTM(dispatch, visitId, servicesInfo,flowType, addlInfo)   
            // contract === ContractConstants.monthToMonth ? fetchFiosData2YR(dispatch, visitId) : buildProductAction.fetchDataMTM(dispatch, visitId, flowType, addlInfo.couponFlowType, action, 0,true, addlInfo, servicesInfo)
            // fetchFiosPerksMTM(dispatch, visitId, servicesInfo,flowType, addlInfo)   // need to test in nte1 
           }  
        if ((flow === DOFlow.onDoFlowInit && !isDoFlow.DOStatus && !addlInfo.ismnhFlow) && !(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow)) {
            //Here getting tarCode = DOIDVALUE 
            if ((isDoFlow.isDoFlow && doKey !== null)) {
                //Open Internet Plans by default for BYOB and DO
                //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                if(isDoFlow.isDoFlow){
                buildProductAction.fetchDOBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, doKey, addlInfo.masterpackageview, addlInfo.servicesQualified,buildProductState,saveState,'');
              }  

                buildProductAction.setDCTEligibility(dispatch, addlInfo.state);
                if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId ,addlInfo.state);
                }
                fetchBasicSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
            }
        }
   
  
    }        
    catch (ex) {
        catchJSException('prefetch', visitId, 'doprefetch', ex);
    }
}

    const doStreamlineprefetch = (dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow, action, buildProductState=null,saveState=null,hoaFlowDetails=null,lqState=null,voicetn="", isRouterAPIInvoked = false) => {
        try {        
        let flowType = addlInfo && addlInfo.flowType;        
        let fdvQualified = false;
        let fiosFiveBasicChannels = [];
        let doKey = isDoFlow.DOIDValue;
        let isDataHOAContract = false;
        let isHOAFlow = false;
        const isStreamlineDataPage =  window?.location?.href?.includes('inhome/streamlineordering');
        const SuppressCalls = lqState?.runtimeKey?.SuppressDuplicateCalls ? lqState.runtimeKey.SuppressDuplicateCalls: '';
        window.localStorage.setItem('isLboTriggered', false);
        if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.hoabundle) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap) && Object.keys(buildProductState.hoabundle.hoaresponse.defaultMap).length>0){
            isHOAFlow = true;
           if(InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['internet']) || InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['data'])){
               isDataHOAContract = true;
            }
        } 
        if(buildProductState && buildProductState.tv && buildProductState.tv.fiosFiveBasicChannels){
            fiosFiveBasicChannels = buildProductState.tv.fiosFiveBasicChannels;
        }
        if (addlInfo && InHomeUtils.isNotNull(addlInfo.servicesQualified) && InHomeUtils.isNotNull(addlInfo.servicesQualified.isVoiceQualified) && addlInfo.servicesQualified.isVoiceQualified){
            fdvQualified = true;
        }
            
        if (flowType === "") {
            flowType = "NC";
        } 
        if(addlInfo.isFCPflow !== true && InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow) {
            doKey = "CLA"; // classic address
        }
        if(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow){
            dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: isHOAFlow , hoaLoadertext : "Fetching Products"} }); 
        }            console.log("servicesInfo.isData",servicesInfo.isData);

        if(!servicesInfo.isData){
            contract === ContractConstants.monthToMonth ? fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) : fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType)

        }else{
        if ((flow === DOFlow.onDoFlowInit && !isDoFlow.DOStatus && !addlInfo.ismnhFlow) && !(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow)) {
            //Here getting tarCode = DOIDVALUE 
            if ((isDoFlow.isDoFlow && doKey !== null)) {
                //Open Internet Plans by default for BYOB and DO
                //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                if(isDoFlow.isDoFlow){
                buildProductAction.fetchDOBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, doKey, addlInfo.masterpackageview, addlInfo.servicesQualified,buildProductState,saveState,'');
              }  

                buildProductAction.setDCTEligibility(dispatch, addlInfo.state);
                if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId ,addlInfo.state);
                }
                fetchStreamlineDataSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
            }
        }
        else if (flow === "REFRESH") {
            if(servicesInfo.isData) {
                contract === ContractConstants.monthToMonth ? fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) : fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType)
            }
            if(servicesInfo.isTV) {
                contract === ContractConstants.monthToMonth ? fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) : fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType)
            }
            if(servicesInfo.isVoice) {
                contract === ContractConstants.monthToMonth ? fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo) : fetchFiosVoice2YR(dispatch, visitId, servicesInfo, flowType)
            }
            if(servicesInfo?.isPerks) {
                (contract === ContractConstants?.monthToMonth) && fetchFiosPerksMTM(dispatch, visitId, servicesInfo,flowType, addlInfo) 
            }

        }
        else {            
            if (flow === "SMART_CART") {                
                fetchStreamlineDataSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
            }

            switch (coreServiceCount) {
                case 0:
                     if(isHOAFlow && isDataHOAContract){
                        fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                   }
                    else {
                    fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action, true);
                  }
                    // fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                    // fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo);
                    fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId,addlInfo.state);
                    }
                    updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                    fetchStreamlineDataSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                    //Open Internet Plans by default for BYOB and DO
                    dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'Init' });
                    break;

                case 1:
                    if (servicesInfo.isData) {
                        //fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                         if(isHOAFlow && isDataHOAContract){
                         fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                         fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                        }
                       else {
                        fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                        //Adding below condition to restrict the duplicate perks api call
                        if(buildProductState?.perks?.plans === null ){
                        fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                       }
                       }
                       
                       fetchStreamlineDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState, isRouterAPIInvoked);
                        if (addlInfo.isFCPflow) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        else {
                            fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                            updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch, flowType);
                        }
                    }
                    else if (servicesInfo.isTV) {
                        fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                        if (addlInfo.isFCPflow) {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        }
                        else {
                            if(isHOAFlow && isDataHOAContract){
                                fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                               }
                              else if(isHOAFlow) {
                               fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                               fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                              }
                              else {
                              fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                              fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                              }
                        }

                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                        if (addlInfo.isFCPflow) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        else {
                            updateServiceLevelContract(isHOAFlow && !isDataHOAContract?ServiceContract.DataMTM:ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        if (!addlInfo.isAlaCarte && fdvQualified) {
                            fetchFiosVoiceMTM(dispatch, visitId, servicesInfo, flowType,addlInfo);
                        }
                    }
                    if (!addlInfo.isAlaCarte && fdvQualified) {
                       // fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo);
                    }

                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length && (!isStreamlineDataPage || SuppressCalls.indexOf('basicffchannel') === -1)) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId,addlInfo.state);
                    }
                    if (servicesInfo.isVoiceAdd) {
                        fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType)
                    }
                    break;

                case 2:
                    if (servicesInfo.isVoice) {
                        if (servicesInfo.isData) {
                             if(isHOAFlow && isDataHOAContract){
                              fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                             }
                            else {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                            fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                            }

                            if (addlInfo.isFCPflow) {
                                fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                            }
                            else {
                                fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch, flowType);
                            }
                        }
                        else if (servicesInfo.isTV) {
                            fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                            if (addlInfo.isFCPflow) {
                                fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                            }
                            else {
                                if(isHOAFlow && isDataHOAContract){
                                    fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                                   }
                                  else  if(isHOAFlow){
                                     fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                                     fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                                  }
                                  else {
                                      fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                                  }
                                updateServiceLevelContract(isHOAFlow && !isDataHOAContract?ServiceContract.DataMTM:ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch, flowType);
                            }
                        }
                        fetchFiosVoiceMTM(dispatch, visitId, servicesInfo, flowType,addlInfo);
                        if (servicesInfo.isVoiceAdd) {
                            fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType)
                        }
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                    }
                    else if (servicesInfo.isData && servicesInfo.isTV) {
                        if (servicesInfo.isLocalTV || contract === ContractConstants.monthToMonth) {
                            fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        }
                        else {
                            if(isHOAFlow && isDataHOAContract){
                                fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                               }
                              else if(isHOAFlow){
                                fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                              }
                              else {
                                fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                              }
                        }

                        if (!isContractSwitched) {
                            fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                            fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        }
                    }
                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId ,addlInfo.state);
                    }
                    break;

                case 3:
                    if ((contract === ContractConstants.monthToMonth) || servicesInfo.isLocalTV || addlInfo.couponFlowType === "Employee" || addlInfo.couponFlowType === "Retiree") {
                        fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                    }
                    else if (contract === ContractConstants.twoYear) {
                        if(isHOAFlow && isDataHOAContract){
                            fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                           }
                          else if(isHOAFlow){
                            fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                          }
                          else {
                            fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                          }
                    }
                    if (!isContractSwitched) {
                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType);
                        
                        if( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length){
                            prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId , addlInfo.state);
                        }
                    }
                    break;
            }
        }
        // console.log(hoaFlowDetails.isHoaFlow+'ishoaenabled');
        if(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow == true){
            buildProductAction.fetchHoaBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, doKey, addlInfo.masterpackageview, addlInfo.servicesQualified,buildProductState,saveState,'');
        }
        if (flow === "INIT" || flow === "SMART_CART") {
            buildProductAction.setDCTEligibility(dispatch, addlInfo.state,flowType);
        }
    }
    }        
    catch (ex) {
        catchJSException('prefetch', visitId, 'doprefetch', ex);
    }
}



    const doprefetch = (dispatch, visitId, servicesInfo, coreServiceCount, contract, isContractSwitched, addlInfo, isDoFlow, flow, action, buildProductState=null,saveState=null,hoaFlowDetails=null,lqState=null,voicetn="") => {
        try {        
        let flowType = addlInfo && addlInfo.flowType;        
        let fdvQualified = false;
        let fiosFiveBasicChannels = [];
        let doKey = isDoFlow.DOIDValue;
        let isDataHOAContract = false;
        let isHOAFlow = false;
        window.localStorage.setItem('isLboTriggered', false);
        if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.hoabundle) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse) && InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap) && Object.keys(buildProductState.hoabundle.hoaresponse.defaultMap).length>0){
            isHOAFlow = true;
           if(InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['internet']) || InHomeUtils.isNotNull(buildProductState.hoabundle.hoaresponse.defaultMap['data'])){
               isDataHOAContract = true;
            }
        } 
        if(buildProductState && buildProductState.tv && buildProductState.tv.fiosFiveBasicChannels){
            fiosFiveBasicChannels = buildProductState.tv.fiosFiveBasicChannels;
        }
        if (addlInfo && InHomeUtils.isNotNull(addlInfo.servicesQualified) && InHomeUtils.isNotNull(addlInfo.servicesQualified.isVoiceQualified) && addlInfo.servicesQualified.isVoiceQualified){
            fdvQualified = true;
        }
            
        if (flowType === "") {
            flowType = "NC";
        } 
        if(addlInfo.isFCPflow !== true && InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow) {
            doKey = "CLA"; // classic address
        }
        if(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow){
            dispatch({ type: 'LOADER_HOA', value: { isLoaderActive: isHOAFlow , hoaLoadertext : "Fetching Products"} }); 
        }
        if ((flow === DOFlow.onDoFlowInit && !isDoFlow.DOStatus && !addlInfo.ismnhFlow) && !(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow)) {
            //Here getting tarCode = DOIDVALUE 
            if ((isDoFlow.isDoFlow && doKey !== null)) {
                //Open Internet Plans by default for BYOB and DO
                //dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                if(isDoFlow.isDoFlow){
                buildProductAction.fetchDOBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, doKey, addlInfo.masterpackageview, addlInfo.servicesQualified,buildProductState,saveState,'');
              }  

                buildProductAction.setDCTEligibility(dispatch, addlInfo.state);
                if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                    prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId ,addlInfo.state);
                }
                fetchBasicSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
            }
        }else if (flow === "Popular"){

         fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) 
         fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType)
         fetchFiosPerksMTM(dispatch, visitId, servicesInfo,flowType, addlInfo) 
           
        }else if (flow === "REFRESH") {
            if(servicesInfo.isData) {
                contract === ContractConstants.monthToMonth ? fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) : fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType)
            }
            if(servicesInfo.isTV) {
                contract === ContractConstants.monthToMonth ? fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType) : fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType)
            }
            if(servicesInfo.isVoice) {
                contract === ContractConstants.monthToMonth ? fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo) : fetchFiosVoice2YR(dispatch, visitId, servicesInfo, flowType)
            }
            if(servicesInfo?.isPerks) {
                (contract === ContractConstants?.monthToMonth) && fetchFiosPerksMTM(dispatch, visitId, servicesInfo,flowType, addlInfo) 
            }

        }
        else {            
            if (flow === "SMART_CART") {                
                fetchBasicSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
            }
            switch (coreServiceCount) {
                case 0:
                     if(isHOAFlow && isDataHOAContract){
                        fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                   }
                    else {
                    fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action, true);
                  }
                    // fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                    // fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo);
                    fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId,addlInfo.state);
                    }
                    updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                    fetchBasicSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                    //Open Internet Plans by default for BYOB and DO
                    dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'Init' });
                    break;

                case 1:
                    if (servicesInfo.isData) {
                        //fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                         if(isHOAFlow && isDataHOAContract){
                         fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                         fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                        }
                       else {
                        fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                        //Adding below condition to restrict the duplicate perks api call
                        if(buildProductState?.perks?.plans === null ){
                        fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                       }
                       }

                        if (addlInfo.isFCPflow && !(flowType.toUpperCase()=== "SUPP" && !servicesInfo.isTVAdd)) {
                            fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        }
                        else {
                            if (!addlInfo.isAlaCarte && !(flowType.toUpperCase()=== "SUPP" && !servicesInfo.isTVAdd)) {
                                fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                            }
                        }                        
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        if (addlInfo.isFCPflow) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        else {
                            fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                            updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch, flowType);
                        }
                    }
                    else if (servicesInfo.isTV) {
                        fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                        if (addlInfo.isFCPflow) {
                            fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        }
                        else {
                            if(isHOAFlow && isDataHOAContract){
                                fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                               }
                              else if(isHOAFlow) {
                               fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                               fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                              }
                              else {
                              fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                              fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                              }
                        }

                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                        if (addlInfo.isFCPflow) {
                            updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        else {
                            updateServiceLevelContract(isHOAFlow && !isDataHOAContract?ServiceContract.DataMTM:ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch, flowType);
                        }
                        if (!addlInfo.isAlaCarte && fdvQualified) {
                            fetchFiosVoiceMTM(dispatch, visitId, servicesInfo, flowType,addlInfo);
                        }
                    }
                    if (!addlInfo.isAlaCarte && fdvQualified) {
                        fetchFiosVoiceMTM(dispatch, visitId, servicesInfo,flowType, addlInfo);
                    }

                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId,addlInfo.state);
                    }
                    if (servicesInfo.isVoiceAdd) {
                        fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType)
                    }
                    break;

                case 2:
                    if (servicesInfo.isVoice) {
                        if (servicesInfo.isData) {
                            const isStreamlineTvVoice =  window?.location?.href?.includes('inhome/streamlinetvvoice');
                            const SuppressDuplicateCalls = store?.getState()?.loopQual?.runtimeKey?.SuppressDuplicateCalls.indexOf('streamlinetv') > -1;
        
                            if(isHOAFlow && isDataHOAContract){
                                fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                            } else if(!isStreamlineTvVoice || (isStreamlineTvVoice && !SuppressDuplicateCalls)){
                                fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                                fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                            }

                            if (addlInfo.isFCPflow) {
                                fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch);
                            }
                            else {
                                fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                updateServiceLevelContract(isHOAFlow && isDataHOAContract?ServiceContract.Data2YR:ServiceContract.DataMTM, ServiceContract.TV2YR, dispatch, flowType);
                            }
                        }
                        else if (servicesInfo.isTV) {
                            fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                            if (addlInfo.isFCPflow) {
                                fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                                fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                                updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
                            }
                            else {
                                if(isHOAFlow && isDataHOAContract){
                                    fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                                   }
                                  else  if(isHOAFlow){
                                     fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType, action);
                                     fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
                                  }
                                  else {
                                      fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
                                  }
                                updateServiceLevelContract(isHOAFlow && !isDataHOAContract?ServiceContract.DataMTM:ServiceContract.Data2YR, ServiceContract.TVMTM, dispatch, flowType);
                            }
                        }
                        fetchFiosVoiceMTM(dispatch, visitId, servicesInfo, flowType,addlInfo);
                        if (servicesInfo.isVoiceAdd) {
                            fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType)
                        }
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                    }
                    else if (servicesInfo.isData && servicesInfo.isTV) {
                        if (servicesInfo.isLocalTV || contract === ContractConstants.monthToMonth) {
                            fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                        }
                        else {
                            if(isHOAFlow && isDataHOAContract){
                                fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                               }
                              else if(isHOAFlow){
                                fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                              }
                              else {
                                fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                              }
                        }

                        if (!isContractSwitched) {
                            fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                            fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        }
                    }
                    if ( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length) {
                        prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId ,addlInfo.state);
                    }
                    break;

                case 3:
                    if ((contract === ContractConstants.monthToMonth) || servicesInfo.isLocalTV || addlInfo.couponFlowType === "Employee" || addlInfo.couponFlowType === "Retiree") {
                        fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                    }
                    else if (contract === ContractConstants.twoYear) {
                        if(isHOAFlow && isDataHOAContract){
                            fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                           }
                          else if(isHOAFlow){
                            fetchAllMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
                          }
                          else {
                            fetchAll2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
                          }
                    }
                    if (!isContractSwitched) {
                        fetchVideoSubProducts(dispatch, visitId, addlInfo, servicesInfo, addlInfo.EquipmentState, flowType);
                        fetchDataSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType,addlInfo.couponFlowType,lqState,voicetn,buildProductState);
                        fetchFiosVoiceSubProducts(dispatch, visitId, servicesInfo, addlInfo.EquipmentState, flowType);
                        
                        if( servicesInfo.isVideoQualified && !fiosFiveBasicChannels.length){
                            prefetchFiosFiveBasicChannels(dispatch, addlInfo.zip, addlInfo.regionId , addlInfo.state);
                        }
                    }
                    break;
            }
        }
        // console.log(hoaFlowDetails.isHoaFlow+'ishoaenabled');
        if(InHomeUtils.isNotNull(hoaFlowDetails) && hoaFlowDetails.isHoaFlow == true){
            buildProductAction.fetchHoaBundle(dispatch, visitId, addlInfo.zip, addlInfo.state, addlInfo.tarCode, doKey, addlInfo.masterpackageview, addlInfo.servicesQualified,buildProductState,saveState,'');
        }
        if (flow === "INIT" || flow === "SMART_CART") {
            buildProductAction.setDCTEligibility(dispatch, addlInfo.state,flowType);
        }
    }        
    catch (ex) {
        catchJSException('prefetch', visitId, 'doprefetch', ex);
    }
}

export const fetchStreamlineDataBasicSubProducts = (dispatch, visitId, addlInfo, servicesInfo, EquipmentState, flowType) => {    
    if (servicesInfo.isDataQualified || servicesInfo.isVideoQualified && addlInfo?.selectedProductId?.length > 0) {
        buildProductAction.fetchRouter(dispatch, visitId, flowType);
    }
    
}

export const fetchBasicSubProducts = (dispatch, visitId, addlInfo, servicesInfo, EquipmentState, flowType) => {    
    if (servicesInfo.isDataQualified || servicesInfo.isVideoQualified && addlInfo?.selectedProductId?.length > 0) {
        buildProductAction.fetchRouter(dispatch, visitId, flowType);
    }
    if (servicesInfo.isVideoQualified) {                
        (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Vroom)) ? buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT, flowType) : {};
        if (addlInfo.isFCPflow && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Recording))) {            
            buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType, flowType);
        }
        (addlInfo.isFCPflow && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Ceapps))) ? buildProductAction.fetchCeapps(dispatch, visitId, '',flowType) : {};
    }
    if (servicesInfo.isDataQualified && addlInfo?.selectedProductId?.length > 0) {
        (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.OTT)) ? buildProductAction.fetchStreamingServices(visitId, dispatch, flowType,addlInfo.couponFlowType) : {};
    }
}

export const fetchDataSubProducts = (dispatch, visitId, servicesInfo, EquipmentState,flowType,couponFlowType,lqState=null,voicetn=null,buildProductState=null) => {
	if(servicesInfo.isDataQualified && !buildProductState?.isResumecartFlow) {   // to avoid multiple equipment call in resumeCart flow
    	(servicesInfo.isDataAdd || servicesInfo.isDataChange || servicesInfo.isTVRemove || servicesInfo.isVoiceRemove) ? buildProductAction.fetchRouter(dispatch, visitId,flowType,0,false,lqState,voicetn,buildProductState) : {};
    	(InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.OTT)) ? buildProductAction.fetchStreamingServices(visitId, dispatch,flowType,couponFlowType) : {};
    	(servicesInfo.isDataAdd || servicesInfo.isDataChange) ? buildProductAction.fetchTechSure(dispatch, visitId,flowType,0,false,lqState,voicetn,buildProductState) : {};
	}
}

export const fetchStreamlineDataSubProducts = (dispatch, visitId, servicesInfo, EquipmentState,flowType,couponFlowType,lqState=null,voicetn=null,buildProductState=null, isRouterAPIInvoked=false) => {
	if(servicesInfo.isDataQualified && !buildProductState?.isResumecartFlow && !isRouterAPIInvoked) {   // to avoid multiple equipment call in resumeCart flow
    	(servicesInfo.isDataAdd || servicesInfo.isDataChange || servicesInfo.isTVRemove || servicesInfo.isVoiceRemove) ? buildProductAction.fetchRouter(dispatch, visitId,flowType,0,false,lqState,voicetn,buildProductState, null) : {};
	}
}

export const fetchVideoSubProducts = (dispatch, visitId, addlInfo, servicesInfo, EquipmentState, flowType) => {
    if(servicesInfo.isVideoQualified) {
        const isStreamlineTvVoice =  window?.location?.href?.includes('inhome/streamlinetvvoice');
        const SuppressDuplicateCalls = store?.getState()?.loopQual?.runtimeKey?.SuppressDuplicateCalls.indexOf('streamlinetv') > -1;
        !servicesInfo.isTVChange && (!isStreamlineTvVoice || (isStreamlineTvVoice && !SuppressDuplicateCalls)) ? buildProductAction.fetchRouter(dispatch, visitId,flowType) : {};

        if (servicesInfo.isTVAdd || servicesInfo.isTVChange) {
            if (addlInfo.isFCPflow) {
                buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT, flowType);
                buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType, flowType);
                buildProductAction.fetchCeapps(dispatch, visitId, '',flowType)
            }
            else {
                (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Vroom)) ? buildProductAction.fetchVRoom(dispatch, visitId, servicesInfo.isLocalTV, servicesInfo.isDCT, flowType) : {};
                (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Recording)) ? buildProductAction.fetchRecording(dispatch, visitId, addlInfo.couponFlowType, flowType) : {};
            }

            buildProductAction.fetchChannel(dispatch, visitId, addlInfo.selectedProductId,flowType);
            (addlInfo.state === "MD" && (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.DCT))) ? buildProductAction.fetchDCT(dispatch, visitId,flowType) : {};
            (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.InternationalChannel)) ? buildProductAction.fetchIntrChannel(dispatch, visitId, '',flowType) : {};
            (InHomeUtils.isNull(EquipmentState) || (InHomeUtils.isNotNull(EquipmentState) && !EquipmentState.Ceapps)) ? buildProductAction.fetchCeapps(dispatch, visitId, '',flowType) : {};
        }
    }
}

export const fetchFiosVoiceSubProducts = (dispatch, visitId, servicesInfo, EquipmentState,flowType) => {
    if (servicesInfo.isVoiceQualified) {
        if (InHomeUtils.isNull(EquipmentState)) {
            buildProductAction.fetchIntlPlans(dispatch, visitId, flowType);
            buildProductAction.fetchListing(dispatch, visitId, flowType);
            buildProductAction.fetchWinbackProducts(dispatch, flowType);
            buildProductAction.fetchBackup(dispatch, visitId, flowType);
        }
        else {
            !EquipmentState.IntlPlans ? buildProductAction.fetchIntlPlans(dispatch, visitId, flowType) : {};
            !EquipmentState.Listing ? buildProductAction.fetchListing(dispatch, visitId, flowType) : {};
            !EquipmentState.Winback ? buildProductAction.fetchWinbackProducts(dispatch, flowType) : {};
            !EquipmentState.Backup ? buildProductAction.fetchBackup(dispatch, visitId, flowType) : {};
        }
    }
}

export const fetchFiosData2YR = (dispatch, visitId, servicesInfo,flowType) => {
    servicesInfo.isDataQualified ? buildProductAction.fetchData2Y(dispatch, visitId,flowType) : {};
}

export const fetchFiosDataMTM = (dispatch, visitId,addlInfo, servicesInfo,flowType, action, isPrefetch = false) => {
    let isResumecartFlow = store?.getState()?.buildProduct?.isResumecartFlow;
    if (servicesInfo.isDataQualified) {
        if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
            buildProductAction.fetchDataMTM(dispatch, visitId, flowType, addlInfo.couponFlowType, action, 0,isPrefetch, addlInfo, servicesInfo);
        }
        else if(!isResumecartFlow){             // to avoid multiple plan call in resumeCart flow
            buildProductAction.fetchDataMTM(dispatch, visitId, flowType, null, action, 0, isPrefetch, addlInfo, servicesInfo);
        }
    }
}

export const fetchFiosTV2YR = (dispatch, visitId, addlInfo, servicesInfo,flowType) => {
    servicesInfo.isVideoQualified ? buildProductAction.fetchTV2Y(dispatch, visitId, addlInfo && addlInfo.zip, addlInfo && addlInfo.tarCode, addlInfo && addlInfo.masterpackageview,flowType) : {};
}

export const fetchFiosTVMTM = (dispatch, visitId, addlInfo, servicesInfo,flowType) => {
    if (servicesInfo.isVideoQualified) {
        if (InHomeUtils.isNotNull(addlInfo) && InHomeUtils.isNotNull(addlInfo.couponFlowType)) {
            buildProductAction.fetchTVMTM(dispatch, visitId, addlInfo.zip, addlInfo.tarCode, addlInfo.masterpackageview, false, addlInfo.couponFlowType, flowType);
        }
        else {
            buildProductAction.fetchTVMTM(dispatch, visitId, addlInfo && addlInfo.zip, addlInfo && addlInfo.tarCode, addlInfo && addlInfo.masterpackageview, "", "", flowType);
        }
    }
}

export const prefetchFiosFiveBasicChannels = (dispatch, zipCode, regionId, state) => {
    buildProductAction.fetchFiosFiveBasicChannels(dispatch, zipCode, regionId , state);
}

export const fetchFiosVoice2YR = (dispatch, visitId, servicesInfo,flowType) => {
    servicesInfo.isVoiceQualified ? buildProductAction.fetchVoice2Y(dispatch, visitId,flowType) : {};
}

export const fetchFiosVoiceMTM = (dispatch, visitId, servicesInfo,flowType,addlInfo) => {
    let couponflowType = addlInfo && addlInfo.couponFlowType ? addlInfo.couponFlowType : null;
    servicesInfo.isVoiceQualified ? buildProductAction.fetchVoiceMTM(dispatch, visitId, couponflowType, flowType) : {};
}

export const fetchFiosPerksMTM = (dispatch, visitId, servicesInfo,flowType,addlInfo) => {
    let couponflowType = addlInfo && addlInfo.couponFlowType ? addlInfo.couponFlowType : null;
    // servicesInfo.isPerksQualified ? buildProductAction.fetchPerksMTM(dispatch, visitId, couponflowType, flowType) : {};
    (servicesInfo.isPerksQualified|| true) ? buildProductAction.fetchPerksMTM(dispatch, visitId, couponflowType, flowType) : {};
}

export const fetchAll2YR = (dispatch, visitId, addlInfo, servicesInfo,flowType) => {
    let fdvQualified = false;
    if (InHomeUtils.isNotNull(addlInfo.servicesQualified) && InHomeUtils.isNotNull(addlInfo.servicesQualified.isVoiceQualified) && addlInfo.servicesQualified.isVoiceQualified) {
        fdvQualified = true
    }
    fetchFiosData2YR(dispatch, visitId, servicesInfo, flowType);
    fetchFiosTV2YR(dispatch, visitId, addlInfo, servicesInfo, flowType);
    if (fdvQualified) {
        fetchFiosVoice2YR(dispatch, visitId, servicesInfo, flowType);
    }

    updateServiceLevelContract(ServiceContract.Data2YR, ServiceContract.TV2YR, dispatch, flowType);
}

export const fetchAllMTM = (dispatch, visitId, addlInfo, servicesInfo,flowType) => {
    const isStreamlineTvVoice =  window?.location?.href?.includes('inhome/streamlinetvvoice');
    const SuppressDuplicateCalls = store?.getState()?.loopQual?.runtimeKey?.SuppressDuplicateCalls.indexOf('streamlinetv') > -1;
    let fdvQualified = false;
    if (InHomeUtils.isNotNull(addlInfo.servicesQualified) && InHomeUtils.isNotNull(addlInfo.servicesQualified.isVoiceQualified) && addlInfo.servicesQualified.isVoiceQualified) {
        fdvQualified = true
    }

    if(!isStreamlineTvVoice || (isStreamlineTvVoice && !SuppressDuplicateCalls)) {
        fetchFiosDataMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
        fetchFiosPerksMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
    }
    fetchFiosTVMTM(dispatch, visitId, addlInfo, servicesInfo, flowType);
    if (fdvQualified) {
        fetchFiosVoiceMTM(dispatch, visitId, servicesInfo, flowType, addlInfo);
    }
    updateServiceLevelContract(ServiceContract.DataMTM, ServiceContract.TVMTM, dispatch, flowType);
}

export const updateServiceLevelContract = (DataContract, TVContract, dispatch, flowType) => {
    if (InHomeUtils.isNotNull(DataContract)) {
      dispatch({ type: "UPDATE_DATA_CONTRACT", value: DataContract });
    }
    if (InHomeUtils.isNotNull(TVContract)) {
      dispatch({ type: "UPDATE_VIDEO_CONTRACT", value: TVContract });
    }
}

export const ServiceContract = {
    DataMTM: "MTM",
    Data2YR: "2YR",
    TVMTM: "MTM",
    TV2YR: "2YR"
}
